import Marketplace from "./Marketplace";
import ProductPage from "./ProductPage";
import CategoryPage from "./CategoryPage";
import SearchResultPage from "./SearchResultPage";
import ProviderPage from "./ProviderPage"

export { Marketplace, ProductPage, CategoryPage, SearchResultPage, ProviderPage };



// WEBPACK FOOTER //
// ./components/marketplace/index.js